module.exports = __webpack_public_path__ + "img/W-12.76d1a3b0.jpg";